<template>
    <div id="app" style="position: relative">

        <!--<div style="width: 100%;background: red;color: white;white-space: nowrap;position: absolute;top: 0">V6
            {{hospitalname}}：{{loginfo}}
        </div>-->

        <div class="flexibleV" style="justify-content: center;height: 100%;pointer-events:painted;position: relative" v-if="if_disp_wait_auto_navi">
            <div class="flexibleH" style="width: 100%;height:50%;justify-content: center;align-content: center;">
                <div class="flexibleV" style="width: 90%;background:bisque;border-radius: 10px; position: relative">
                    <div style="height: 10%;margin-top: 30px;font-size: 16px;" v-if="!auto_navi_error">即将自动导航到目的地</div>
                    <div style="height: 10%;font-size: 16px" v-if="!auto_navi_error">正在定位…</div>
                    <div style="height: 20%;margin-top: 30px;font-size: 16px;" v-if="auto_navi_error">无法自动找到目的地，请手工搜索
                    </div>
                    <div class="flexibleH" style="height: 70%;justify-content: center;margin-top: -20px">
                        <img style="width: 60%;height:84%" src="../public/static/transit.gif"/>   <!--h423 w304-->
                    </div>
                    <div style="height: 10%;margin-top: -20px;text-decoration:underline" @click="cancel_auto_navi()">
                        算了，我手动搜索目的地
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    //从map调用vue用     call_vue( para )
    //从vue调用map     直接调用相关函数的定义

    //let wx


    export default {
        name: 'App',
        /*components: {
          HelloWorld
        }*/

        data() {
            return {
                loginfo: '',
                hospitalname: '调试',
                if_disp_wait_auto_navi: false,//是否显示正在等待自动导航
                auto_navi_error: null,//错误原因，hiscode_error 表示没有his编码错误
            }
        },

        mounted() {

            window.Fun_Map_call_Vue = this.call_vue
            window.if_vue_start = true

            /*this.disinfo('准备跳转')
            setTimeout(() => {
                window.wx.miniProgram.navigateTo({
                    url: '/pages/map/voiceSearch?name=test',
                    success:function () {
                        this.disinfo('跳转成功')
                    },
                    fail:function () {
                        this.disinfo('跳转失败')
                    }
                })
            }, 3000)*/
        },

        methods: {

            //取消自动导航
            cancel_auto_navi() {
                this.if_disp_wait_auto_navi = false
                window.that.cancel_auto_navi = true
            },

            //从vue外部调用vue的函数，类似代理的概念
            call_vue(input) {
                switch (input.event) {
                    case "map.loadComplete":
                        this.disinfo('地图加载完成')
                        switch (input.esmapID) {
                            case "40010":
                                this.hospitalname = '南湖'
                                break
                            case "40011":
                                this.hospitalname = '沈北'
                                break
                            case "40012":
                                this.hospitalname = '滑翔'
                                break
                            default:
                                break
                        }
                        break

                    case "route.change":
                        this.disinfo(input.info)
                        break

                    //自动导航，但是还没有获取到当前位置
                    case 'autonavi_but_no_start_location':
                        //console.log('---------------- autonavi_but_no_start_location ---------------------')
                        this.auto_navi_error = null
                        this.if_disp_wait_auto_navi = !window.that.cancel_auto_navi;//如果在等待自动导航过程中，用户取消了，那么就不再显示等待框了
                        break

                    //自动导航，获取到了当前位置
                    case 'autonavi_get_start_location':
                        this.if_disp_wait_auto_navi = false
                        break

                    //自动导航，但是his编码没有找到对应的poi id
                    case 'autonavi_but_hiscode_error':
                        //console.log('---------------- autonavi_but_hiscode_error ---------------------')
                        this.auto_navi_error = 'hiscode_error'
                        this.if_disp_wait_auto_navi = true

                        //5秒后自动消失提示框
                        setTimeout(() => {
                            this.if_disp_wait_auto_navi=false
                        }, 5000);

                        break

                    /*case "wx":
                        wx = obj
                        console.log('微信对象',window.wx)
                        console.log('map',window.map)
                        this.disinfo('加载微信')
                        break*/
                    default:
                        this.disinfo(input)
                        break
                }
            },

            disinfo() {
            },

            /*disinfo(info) {
                this.loginfo = info + '(' + this.getNowFormatDate() + ')' + this.loginfo.substring(0, 50);
            },*/

            getNowFormatDate() {//获取当前时间
                var date = new Date();
                //var seperator1 = "-";
                var seperator2 = ":";
                //var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
                //var strDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                return date.getHours() + seperator2 + date.getMinutes()
                    + seperator2 + date.getSeconds();
            }

        },
    }
</script>

<style>
    #app {
        /*font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;*/
        /*background-color:rgba(0,0,0,0);*/
        width: 100vw;
        height: 100vh;
        z-index: 100;
        position: relative;
        pointer-events: none;
    }

    .flexibleV {
        display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox; /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */

        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    /*水平弹性盒子*/
    .flexibleH {
        display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox; /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */

        /* background: greenyellow;*/
        justify-content: space-around;
    }
</style>
